var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPosts1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M14.9438 8.26259C15.2472 7.89916 15.1975 7.35915 14.8341 7.05572C14.4706 6.75228 13.9298 6.802 13.6272 7.16543L9.34144 11.4512C9.30715 11.4915 9.29087 11.5395 9.26515 11.5841C9.24458 11.6192 9.22058 11.6501 9.20515 11.6886C9.16572 11.7889 9.14258 11.8935 9.14258 11.9998C9.14258 12.1061 9.16572 12.2106 9.20515 12.3109C9.22058 12.3495 9.24458 12.3804 9.26515 12.4155C9.29087 12.4601 9.30715 12.5081 9.34144 12.5484L13.6272 16.8341C13.9298 17.1984 14.4706 17.2473 14.8341 16.9438C15.1975 16.6413 15.2472 16.1013 14.9438 15.737L11.8298 12.8569L10.9727 11.9999L11.8318 11.1407L14.9438 8.26259Z",
    fill: "#9295A6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosts1);
export default __webpack_public_path__ + "static/media/posts1.31093f72234d6b8db958a58110e470a7.svg";
export { ForwardRef as ReactComponent };